<template>
  <b-form-group
    label="Telefon"
    label-for="phone"
  >
    <b-input-group>
      <b-input-group-prepend is-text>
        TR (+9)
      </b-input-group-prepend>
      <cleave
        id="phone"
        v-model="itemData.phone"
        class="form-control"
        :raw="false"
        :options="options.phone"
        placeholder="Telefon"
      />
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'PhoneNumber',
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    Cleave,
  },
  data() {
    return {
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contacts/dataItem']
    },
  },
}
</script>
